// Global
var initGoogleSearch = function() {

    var notReadyHandle = function() {
        // Render an element with both search box and search results in div with id 'test'.
        google.search.cse.element.render(
            {
                div: "google-search-results",
                tag: 'searchresults-only',
                gname: "google-search"
            });
    };


    if (document.readyState == 'complete') {
        // Document is ready when CSE element is initialized.
        // Render an element with both search box and search results in div with id 'test'.
        google.search.cse.element.render(
            {
                div: "google-search-results",
                tag: 'searchresults-only',
                gname: "google-search"
            });

    } else {

        if (navigator.userAgent.toLowerCase().indexOf('msie') > 0) {
            $(document).ready(notReadyHandle()); // IE : Use a jQuery document ready
        }

        else {
            // Document is not ready yet, when CSE element is initialized.
            google.setOnLoadCallback(function() {
                notReadyHandle();
            }, true);
        }
    }
};

// Insert it before the CSE code snippet so that cse.js can take the script
// parameters, like parsetags, callbacks.
window.__gcse = {
    parsetags: 'explicit',
    callback: initGoogleSearch
};

// Copy/paste code from google custom search
(function() {
    var cx = gcscx; // Google Custom Search CX code, rendered in template file
    var gcse = document.createElement('script');
    gcse.type = 'text/javascript';
    gcse.async = true;
    gcse.src = 'https://cse.google.com/cse.js?cx=' + cx;
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(gcse, s);
})();


$("#search-form").submit(function(event) {
    event.preventDefault();
    //Remove focus from input after subnmit
    $(this['search-input']).blur();
    // Add search query string in search popup header
    document.getElementById('google-search-term').innerText = this['search-input'].value;
    // Init Google Custom search
    var element = google.search.cse.element.getElement('google-search');
    element.execute(this['search-input'].value);
});